"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var TranslationReducer_InitialState = exports.TranslationReducer_InitialState = {
	activeLanguage: null,
	availableLanguages: [],
	allTranslations: {}
};